module.exports = __webpack_public_path__ + "img/wximg6.9714ea05.png";